<template>
  <div class="container-fluid container-wrap col-sm-12 col-xs-12">
        <div class="row justify-content-center">
            <div class="col-sm-12 col-xs-12">
                <div class="pb-0 col-sm-12 d-flex mainDiv">
                    <div class="col-sm-12 col-xs-12">
                        <!-- 제조사 선택 UI (companyName 쿼리 없을 때) -->
                        <template v-if="!$route.query.companyName">
                            <div class="col-sm-12 col-xs-12 titleDiv CertListTitle justify-content-between title-area">
                                <div>
                                    <h3>품목 관리</h3>
                                    <h5>미제휴 제조사의 품목을 관리할 수 있습니다. 제조사를 선택해 주세요.</h5>
                                </div>
                            </div>
                            <div class="manufacturer-select-area">
                                <a-select
                                    v-model:value="selectedCompanyName"
                                    show-search
                                    placeholder="제조사를 선택하세요"
                                    style="width: 400px;"
                                    :filter-option="filterManufacturerOption"
                                    @change="handleManufacturerSelect"
                                >
                                    <a-select-option
                                        v-for="manufacturer in manufacturerList"
                                        :key="manufacturer._id"
                                        :value="manufacturer.companyName"
                                    >
                                        {{ manufacturer.companyName }}
                                    </a-select-option>
                                </a-select>
                            </div>
                        </template>

                        <!-- 기존 품목 관리 UI (companyName 쿼리 있을 때) -->
                        <template v-else>
                        <div
                            class="col-sm-12 col-xs-12 titleDiv CertListTitle  justify-content-between title-area"
                        >
                            <div>
                                <h3>{{ $route.query.companyName }} 품목 관리</h3>
                                <h5>인증서를 발행할 품목을 관리할 수 있습니다.</h5>
                            </div>
                            <div class="button-group">
                                <a-button
                                    type="default"
                                    @click="routeToBulkEdit"
                                >
                                    <i class="fa-solid fa-table"/>
                                    엑셀형식으로 수정하기
                                </a-button>
                                <a-button
                                    type="primary"
                                    @click="routeToAddItem"
                                >
                                    <i class="fa-regular fa-plus"/>
                                    품목 등록
                                </a-button>
                            </div>
                        </div>
                        <div class="card-body px-0 pt-0 pb-2 table-with-search">
                            <div class="col-xs-12 table-info-filter">
                                <div class="total-div">
                                    <p>
                                        전체 <span class="number-highlight">{{ formatCommaNumber(listSize) }}</span>건
                                    </p>
                                </div>
                                <div class="search-container">
                                    <a-select
                                        v-model:value="rowsPerPage"
                                        @change="handleRowsPerPage"
                                        style="width: 150px;"
                                    >
                                        <a-select-option :value="10">10개씩 보기</a-select-option>
                                        <a-select-option :value="20">20개씩 보기</a-select-option>
                                        <a-select-option :value="50">50개씩 보기</a-select-option>
                                    </a-select>
                                    <div class="search-div">
                                        <a-select
                                            v-model:value="searchFilter"
                                            id="searchFilter"
                                            class="no-radius-right"
                                            placeholder="선택"
                                            style="width: 100px"

                                        >
                                            <a-select-option value="" selected>
                                                선택
                                            </a-select-option>
                                            <a-select-option value="itemName">
                                                품목명
                                            </a-select-option>
                                            <a-select-option value="itemCode">
                                                품목 코드
                                            </a-select-option>
                                        </a-select>
                                        <div class="typing-area">
                                            <a-input
                                                placeholder="품목명 또는 품목 코드를 입력하세요."
                                                v-model:value="condition"
                                                @keyup.enter="enter"
                                                class="no-radius-all"
                                                style="height: 100%; width: 250px;"
                                            />
                                            <a-button
                                                @click="enter"
                                                class="black no-radius-left"
                                                style="height: 100%;"
                                            >
                                                검색
                                            </a-button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <a-table
                                class="ant-table-striped"
                                size="small"
                                :columns="columns"
                                :data-source="responseData"
                                :pagination="false"

                            >
                                    <template #emptyText>
                                        <div class="noData">
                                            <i class="fa-solid fa-exclamation-triangle" style="font-size: 24px; margin-bottom: 10px"/><br>
                                            <span>{{computedNoResultMessage}}</span>
                                        </div>
                                    </template>
                                    <template #bodyCell="{ column, record }">
                                    </template>
                            </a-table>
                        </div>
                        <pagination
                        v-if="!$store.state.isLoading && responseData.length > 0"
                        :page-info="paginationData"
                        page-name="ItemList"
                        @change-page="paginationHandler"
                        />
                        </template>
                    </div>
                </div>
            </div>
        </div>
  </div>
</template>

<script>
import { 
    convertDate, 
    oneBtnDialog, 
    confirmDialog, 
    jwtDecoder,
    formatCommaNumber,
} from '@/utils/utils';
import {
    enums,
    MedicalDept,
} from '@/utils/enums'
import NoResult from '@/views/components/NoResult.vue';
import Pagination from '@/views/components/Pagination.vue';

export default {
    name: 'ItemList',
    components: {
        NoResult,
        Pagination,
    },
    computed: {
        computedNoResultMessage() {
        if(this.calledApiTimes <= 1) {
            return '아직 등록된 품목이 없습니다';
        } else {
            return '검색 결과가 없습니다.';
        }
        },
    },
    data() {
        return {
        formatCommaNumber,
        addItemPath: '/item/add',
        modalData: '',
        isInputFocused: false,
        manufacturerList: [],
        selectedCompanyName: undefined,

        // 목록 받아오는 변수
        responseData: [],

        // 페이지네이션 관련 변수
        searchFilter: undefined,
        previousCondition: '',
        condition: '',
        calledApiTimes: 0,

        selectedItem: '',
        itemDetailData: {},
        deptList: [],
        isZeiss: false,

        columns:[
                {
                    key: 'index', title: '번호', dataIndex: 'index', align: 'center', width: "4%",
                },
                {
                    key: 'medicalDept', title: '과', dataIndex: 'medicalDept', align: 'start',
                    customRender: ({text, record}) => {
                        // TEXT 단건이기 때문에 없어도 됨
                        return this.convertDeptToText(record.medicalDept)
                    },
                },
                {
                    key: 'productType', title: '제품분류', dataIndex: 'productType', align: 'start',
                    customRender: ({text, record}) => {
                        return record.productType || '-';
                    },
                },
                {
                    key: 'itemCode', title: '품목코드', dataIndex: 'itemCode', align: 'start',
                    customRender: ({text, record}) => {
                        return record.itemCode || '-';
                    },
                },
                {
                    key: 'itemName', title: '품목명', dataIndex: 'itemName', align: 'start',
                    customRender: ({text, record}) => {
                        return record.itemName || '-';
                    },
                },
                {
                    key: 'warrantyStatus', title: '무등록발행', dataIndex: 'warrantyStatus', align: 'center',
                    customRender: ({text, record}) => {
                        return (
                            <div class="status-wrap-align">
                                <span class="status-wrap">
                                {
                                    record.unregisterYn === enums().YnEnum.Y
                                        ? '가능'
                                        : '불가'
                                }
                                </span>
                            </div>
                        );
                    },
                },
                {
                    key: 'duplicateYn', title: '중복 등록 허용', dataIndex: 'duplicateYn', align: 'center',
                    customRender: ({text, record}) => {
                        return (
                            <div class="status-wrap-align">
                                <span class="status-wrap">
                                {
                                    record.duplicateYn === enums().YnEnum.Y
                                        ? '가능'
                                        : '불가'
                                }
                                </span>
                            </div>
                        );
                    },
                },
                {
                    key: 'itemCount', title: '등록 제품 수', dataIndex: 'itemCount', align: 'center',
                    customRender: ({text, record}) => {
                        return this.formatCommaNumber(record.itemCount)
                    },
                },
                {
                    key: 'modify-button', title: '수정', dataIndex: '_id', align: 'center',
                    customRender: ({text, record}) => {
                        return (
                            <div
                                style="width: 100%; justify-content: center; display: flex;"
                            >
                                <a-button 
                                    shape="circle"
                                    onClick={() => {
                                        this.routeToModifyItemPage(record._id);
                                    }}
                                    icon={<i class="fa-regular fa-pen-to-square" />}
                                />  
                            </div>
                        )
                    },
                },
                {
                    key: 'delete-button', title: '삭제', dataIndex: '_id', align: 'center',
                    customRender: ({text, record}) => {
                        if(record.isDeleted) {
                            return '';
                        }
                        return (
                            <div
                                style="width: 100%; justify-content: center; display: flex;"
                            >
                                <a-button 
                                    shape="circle"
                                    onClick={() => this.deleteItem(record._id)}
                                    icon={<i class="fa-solid fa-trash-can" />}
                                />    
                            </div>
                        )
                    },
                },
            ],

        listSize: 0,
        rowsPerPage: 10, // Default, can be changed by the user
        paginationData: {
            currentPage: 1, 
            totalPages: 0,
        },
        };
    },
    watch: {
        async '$route'(to, from) {
            if(to.name == 'ItemList'){
                if (!to.query.companyName) {
                    await this.getManufacturerList();
                    return;
                }
                await this.getDeptList();
                this.checkIsZeiss();

                const obj = {};
                obj.page = this.paginationData.currentPage;
                this.paginationHandler(obj);
            }
        }
    },
    async mounted() {
        if (!this.$route.query.companyName) {
            await this.getManufacturerList();
            return;
        }
        await this.getDeptList();
        this.checkIsZeiss();

        const obj = {};
        obj.page = this.paginationData.currentPage;
        this.paginationHandler(obj);
    },
    methods: {
        convertDate,
        async getManufacturerList() {
            try {
                const response = await this.$apiInstance.post(`/companies/certi-admin/unaffiliated-manufacturers`, { page: 1, limit: 9999 });
                if (response.status === 200 || response.status === 201) {
                    this.manufacturerList = response.data.docs || response.data || [];
                }
            } catch (error) {
                console.log(error);
                await oneBtnDialog('제조사 목록 로드 실패', '제조사 목록 로드에 실패하였습니다.', false);
            }
        },
        filterManufacturerOption(input, option) {
            return option.children?.[0]?.children?.toLowerCase().includes(input.toLowerCase())
                || option.value?.toLowerCase().includes(input.toLowerCase());
        },
        handleManufacturerSelect(companyName) {
            this.$router.push(`/item/list?companyName=${encodeURIComponent(companyName)}`);
        },
        checkIsZeiss() {
            const companyId = jwtDecoder(localStorage.getItem('accessTokenManu'));
            if(companyId && companyId === process.env.VUE_APP_ZEISS_ID) {
                this.isZeiss = true;
            }
        },
        routeToAddItem() {
            this.$router.push(this.addItemPath+`?companyName=${this.$route.query.companyName}`);
        },
        routeToBulkEdit() {
            this.$router.push(`/item/bulk-edit?companyName=${this.$route.query.companyName}`);
        },
        // 주요 API
        async paginationHandler(childPassParam) {
            this.paginationData.currentPage = childPassParam.page;
            await this.getItemsList();
        },
        //삭제 공통 confirm 모달
        async deleteItem(itemId) {
            this.selectedItem = itemId;
            try {
                const confirmResult = await confirmDialog('품목 삭제', '품목을 삭제하시겠습니까? 이 작업은 되돌릴 수 없습니다.');
                if (confirmResult) {
                const response = await this.$apiInstance.delete(`/items/${this.selectedItem}`);
                if (response.status === 200 || response.status === 201) {
                    await oneBtnDialog('품목 삭제 완료', '삭제 완료 되었습니다.', true);
                }
                }
            } catch(error) {
                console.log(error);
                await oneBtnDialog('품목 삭제 실패', '삭제에 실패하였습니다.', false);
            }
        },
        // 과 목록 가져오기
        async getDeptList() {
            try {
                const response = await this.$apiInstance.get(`/items/medical/depts`);
                if (response.status === 200 || response.status === 201) {
                    this.deptList = response.data.filter(item => item.code !== MedicalDept.COMMON);
                }
            } catch (error) {
                console.log(error);
                await oneBtnDialog('진료 과목 로드 실패','진료 과목 로드에 실패하였습니다.', false);
            }
        },
        async enter() {
            if (this.searchFilter === '') {
                await oneBtnDialog('검색 필터 미선택', '검색 필터를 선택해 주세요.', false);
            } else {
                this.paginationData.currentPage = 1;
                this.getItemsList();
            }
        },
        // 품목 리스트 가져오기
        async getItemsList() {
            const params = {};
            if(this.previousCondition !== this.condition) {
                params.page = 1;
            } else {
                params.page = this.paginationData.currentPage;
            }
            params.companyName = this.$route.query.companyName;
            params.limit = this.rowsPerPage;
            if (this.searchFilter !== '' && this.condition !== '') {
                params.search = this.searchFilter;
                params.condition = this.condition;
            }
            try {
                const response = await this.$apiInstance.get(`/items/by-company-name`, { params });
                if (response.status === 200 || response.status === 201) {
                this.calledApiTimes ++;

                if(this.previousCondition !== this.condition) {
                    this.paginationData.currentPage = 1;
                } 
                this.previousCondition = this.condition;
                if(response.data.docs) {
                    this.responseData = response.data.docs;
                } else {
                    this.responseData = [];
                }
                this.listSize = response.data.totalDocs;
                for (let i = 0; i < this.responseData.length; i++) {
                    this.responseData[i].index = this.listSize - (this.paginationData.currentPage - 1) * this.rowsPerPage  - i;
                }
                this.paginationData.totalPages = response.data.totalPages;
            }
        } catch (error) {
            console.log(error);
            await oneBtnDialog('품목 목록 로드 실패', '품목 목록 로드에 실패하였습니다.', false);
        }
        },

        // 품목 상세
        async routeToModifyItemPage(itemId) {
            this.$router.push({name: 'ModifyItem', params: { itemId },query:{ companyName:this.$route.query.companyName},});
        },
        async handleRowsPerPage() {
            this.paginationData.currentPage = 1;
            await this.getItemsList();
        },
        // 인증서 상태 코드 텍스트로 변환
        // 과명 변환
        convertDeptToText(code) {
            const department = this.deptList.find((item) => item.code === code);
            return department ? department.name : '-';
        },
    },
};
</script>
<style lang="scss" scoped>
@import '../assets/scss/common-css.scss';

.manufacturer-select-area {
    display: flex;
    align-items: center;
    padding: 40px 0;
}

.button-group {
    display: flex;
    gap: 8px;
}

.ant-btn {
    border-radius: 6px;
}
.ant-switch{
    border-radius: 100px;
}
.row {
    padding: 28px 28px 72px 28px !important;
}
.ant-table-wrapper {
    overflow-x: auto;
    background-color: white;
}
.ant-btn-primary {
    background-color: #ffe414;
}
.ant-btn {
    color: #17191C;
    height: 40px;
    box-shadow: none !important;
    transition: ease-in-out 0.3s;
    padding: 13px 18px;
    display: flex;
    gap: 8px;
    align-items: center;
    justify-content: center;
    transition: ease-in-out 0.3s;
}
@media screen and (max-width:767px) {
    .search-container {
        gap: 8px !important;
        .search-div {
            flex-direction: row;
            gap: 0px;
            .ant-select{
                width: 150px !important;
            }
            .typing-area{
                width: 100%;
                gap: 0;
            }
        }
    }

    .container-fluid .row.justify-content-center{
        padding: 14px 14px 36px 14px !important;
    }
    .mainDiv{
        width: 100% !important;
    }
    .header-btn{
        margin-left: auto;
    }
    .table-with-search .table-info-filter{
        flex-direction: column;
        align-items: flex-start;
        flex: none;
        justify-content: flex-start;
        height: 210px;
    }

    .table-with-search .search-container .search-div input,
    .table-with-search .search-container .search-div button{
        width: 60px !important;
        min-width: auto;
        display: inline-flex;
        align-items: center;
        justify-content: center;
    }

    .table-with-search .search-container .search-div input{
        width: calc(100% - 60px)!important;
    }

    #searchFilter{
        display: flex;
        flex-wrap: row;
    }
    .table-with-search .search-container,
    .table-with-search .search-container .search-div,
    .table-with-search .search-container select{
            width: 100%;
            flex: none;
        }
}

@media screen and (min-width:768px) and (max-width:1023px){
    .table-with-search .table-info-filter{
        flex-direction: column;
        width: 100%;
        .total-div{
            margin-right: auto;
        }
        .search-container{
            width: 100%;
            flex-direction: row;
            .search-div{
                flex-direction: row;
                width: 100%;
                input{
                width: calc(100% - 80px) !important;
                }
                .search-btn{
                min-width: 80px;
                }
            }
        }
    }
}
</style>
